'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');
var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WebcacheApi = function (_BaseApi) {
  (0, _inherits3.default)(WebcacheApi, _BaseApi);
  function WebcacheApi() {
    (0, _classCallCheck3.default)(this, WebcacheApi);
    return (0, _possibleConstructorReturn3.default)(this, (WebcacheApi.__proto__ || Object.getPrototypeOf(WebcacheApi)).call(this, _frontendUtils.endpoints.webcacheBaseUrl));
  }
  (0, _createClass3.default)(WebcacheApi, [{
    key: 'getResource',
    value: function getResource(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!ValidationUtils.isNonEmptyOrBlankString(url)) {
        return Promise.reject(new _ParameterError2.default('url', url, 'non-empty string.'));
      }
      options.url = url;
      return this.makeRequest({
        url: 'fetch',
        queryParameters: options
      });
    }
  }, {
    key: 'getResourcePost',
    value: function getResourcePost(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!ValidationUtils.isNonEmptyOrBlankString(url)) {
        return Promise.reject(new _ParameterError2.default('url', url, 'non-empty string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'fetch',
        queryParameters: {
          url: url,
          rendererBackend: options.rendererBackend
        },
        body: options
      });
    }
  }, {
    key: 'getPage',
    value: function getPage(resourceId) {
      return this.makeRequest({
        url: 'resource/' + resourceId
      }).then(function (response) {
        return response.text();
      });
    }
  }, {
    key: 'getHTML',
    value: function getHTML(url) {
      var _this2 = this;
      return this.getResource(url).then(function (resource) {
        if (resource.statusCode < 200 || resource.statusCode >= 300) {
          throw new Error(resource.statusCode);
        }
        return resource;
      }).then(function (_ref) {
        var resourceId = _ref.resourceId;
        return _this2.getPage(resourceId);
      });
    }

    /**
     * Gets the VirtualBrowser from Webcache API. VirtualBrowser is used on the server
     * side to mock user session.
     * @param   {String} domain               Domain that will be extracted utilizing this virtual browser.
     * @param   {String} rendererId           Id of the renderer that is requesting the virtual browser.
     *                                        Backend identifies that way if it is webkit or chromium that requested it.
     * @param   {String} [userGuid=undefined] Id of the user for whom the virtual browser is requested.
     * @throws  {Promise<ParameterError>}     If provided parameters are not valid, function will reject with
     *                                        this error before making the request.
     * @throws  {Promise<ResponseError>}      If the request will return with non-sucessful status code,
     *                                        this function will reject with a ResponseError.
     * @returns {Promise}                     Function resolves with the response body if the request returned
     *                                        with a successful status code.
     */
  }, {
    key: 'checkOutVirtualBrowser',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
        var domain, rendererId, userGuid, proxyType, country;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                domain = params.domain, rendererId = params.rendererId, userGuid = params.userGuid, proxyType = params.proxyType, country = params.country;
                if (ValidationUtils.isNonEmptyOrBlankString(domain)) {
                  _context.next = 3;
                  break;
                }
                throw new _ParameterError2.default('domain', domain, 'non-empty string.');
              case 3:
                if (ValidationUtils.isGuid(rendererId)) {
                  _context.next = 5;
                  break;
                }
                throw new _ParameterError2.default('rendererId', rendererId, 'guid string.');
              case 5:
                if (ValidationUtils.isUndefinedOr(ValidationUtils.isGuid, userGuid)) {
                  _context.next = 7;
                  break;
                }
                throw new _ParameterError2.default('userGuid', userGuid, 'guid string.');
              case 7:
                return _context.abrupt('return', this.makeRequest({
                  url: 'virtualbrowser',
                  headers: {
                    'X-Renderer-Key': rendererId
                  },
                  queryParameters: {
                    domain: domain,
                    userGuid: userGuid,
                    proxyType: proxyType,
                    country: country
                  }
                }));
              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function checkOutVirtualBrowser(_x3) {
        return _ref2.apply(this, arguments);
      }
      return checkOutVirtualBrowser;
    }()

    /**
     * Creates/get a VirtualBrowser from Webcache API for login session. Either 'virtualBrowserId' or 'userGuid' must be set.
     * When 'userGuid' is set, a new VirtualBrowser will be created in Webcache and returned.
     * When 'virtualBrowserId' is set, corresponding VirtualBrowser will returned.
     * When both set, will get VirtualBrowser of virtualBrowserId.
     *
     * @param   {String} domain               Domain that will be extracted utilizing this virtual browser.
     * @param   {String} rendererId           Id of the renderer that is requesting the virtual browser.
     *                                        Backend identifies that way if it is webkit or chromium that requested it.
     * @param   {String} [userGuid=undefined] Id of the user for whom the virtual browser is requested. When set a new
     *                                        VirtualBrowser will be created in Webcache.
     * @param   {String} [virtualBrowserId=undefined]   Id of the VirtualBrowser to get.
     * @throws  {Promise<ParameterError>}     If provided parameters are not valid, function will reject with
     *                                        this error before making the request.
     * @throws  {Promise<ResponseError>}      If the request will return with non-sucessful status code,
     *                                        this function will reject with a ResponseError.
     * @returns {Promise}                     Function resolves with the response body if the request returned
     *                                        with a successful status code.
     */
  }, {
    key: 'checkOutVirtualBrowserSession',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(params) {
        var domain, rendererId, userGuid, virtualBrowserId, proxyType, country;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                domain = params.domain, rendererId = params.rendererId, userGuid = params.userGuid, virtualBrowserId = params.virtualBrowserId, proxyType = params.proxyType, country = params.country;
                if (ValidationUtils.isNonEmptyOrBlankString(domain)) {
                  _context2.next = 3;
                  break;
                }
                throw new _ParameterError2.default('domain', domain, 'non-empty string.');
              case 3:
                if (ValidationUtils.isGuid(rendererId)) {
                  _context2.next = 5;
                  break;
                }
                throw new _ParameterError2.default('rendererId', rendererId, 'guid string.');
              case 5:
                if (ValidationUtils.isUndefinedOr(ValidationUtils.isGuid, virtualBrowserId)) {
                  _context2.next = 7;
                  break;
                }
                throw new _ParameterError2.default('virtualBrowserId', virtualBrowserId, 'guid string.');
              case 7:
                if (ValidationUtils.isUndefinedOr(ValidationUtils.isGuid, userGuid)) {
                  _context2.next = 9;
                  break;
                }
                throw new _ParameterError2.default('userGuid', userGuid, 'guid string.');
              case 9:
                if (!(virtualBrowserId === undefined && userGuid === undefined)) {
                  _context2.next = 11;
                  break;
                }
                throw new _ParameterError2.default('userGuid, virtualBrowserId', {
                  userGuid: userGuid,
                  virtualBrowserId: virtualBrowserId
                }, 'Either userGuid or virtualBrowserId is required.');
              case 11:
                return _context2.abrupt('return', this.makeRequest({
                  url: 'virtualbrowser/session',
                  headers: {
                    'X-Renderer-Key': rendererId
                  },
                  queryParameters: {
                    domain: domain,
                    userGuid: userGuid,
                    proxyType: proxyType,
                    country: country,
                    virtualBrowserId: virtualBrowserId
                  }
                }));
              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function checkOutVirtualBrowserSession(_x4) {
        return _ref3.apply(this, arguments);
      }
      return checkOutVirtualBrowserSession;
    }()

    /**
     * Returns the VirtualBrowser to Webcache API. Additionally it specifies if the virtual browser
     * got blocked (for example captcha was shown) while being used.
     * @param   {Object}  virtualBrowser            Virtual browser used during the request.
     * @param   {String}  domain                    Domain that was extracted utilizing this virtual browser.
     * @param   {String}  rendererId                Id of the renderer that is requesting the virtual browser.
     *                                              Backend identifies that way if it is webkit or chromium that requested it.
     * @param   {Boolean} [blocked=false]           Flag stating if virtual browser got blocked while being used.
     * @param   {Number}  [statusCode=undefined]    Status code that the page returned. Only required if blocked=true.
     * @param   {Number}  [blockMessage=undefined]  A string to identify why a proxy was blocked in the case that no status code was returned.
     *                                              NOTE: Either blockMessage or statusCode must be set if blocked is true.
     * @throws  {Promise<ParameterError>}           If provided parameters are not valid, function will reject with
     *                                              this error before making the request.
     * @throws  {Promise<ResponseError>}            If the request will return with non-sucessful status code,
     *                                              this function will reject with a ResponseError.
     * @returns {Promise}                           Function resolves with the response body if the request returned
     *                                              with a successful status code.
     */
  }, {
    key: 'checkInVirtualBrowser',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(virtualBrowser, domain, rendererId) {
        var blocked = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var statusCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
        var blockMessage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (ValidationUtils.isObject(virtualBrowser)) {
                  _context3.next = 2;
                  break;
                }
                throw new _ParameterError2.default('virtualBrowser', virtualBrowser, 'object.');
              case 2:
                if (ValidationUtils.isNonEmptyOrBlankString(domain)) {
                  _context3.next = 4;
                  break;
                }
                throw new _ParameterError2.default('domain', domain, 'non-empty string.');
              case 4:
                if (ValidationUtils.isGuid(rendererId)) {
                  _context3.next = 6;
                  break;
                }
                throw new _ParameterError2.default('rendererId', rendererId, 'guid string.');
              case 6:
                if (ValidationUtils.isBoolean(blocked)) {
                  _context3.next = 8;
                  break;
                }
                throw new _ParameterError2.default('blocked', blocked, 'boolean.');
              case 8:
                if (!(blocked && !ValidationUtils.isUndefinedOr(ValidationUtils.isNumber, statusCode))) {
                  _context3.next = 10;
                  break;
                }
                throw new _ParameterError2.default('statusCode', statusCode, 'number.');
              case 10:
                if (!(blocked && !ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, blockMessage))) {
                  _context3.next = 12;
                  break;
                }
                throw new _ParameterError2.default('blockMessage', blockMessage, 'non-empty string.');
              case 12:
                if (!(blocked && !ValidationUtils.isNumber(statusCode) && !ValidationUtils.isNonEmptyOrBlankString(blockMessage))) {
                  _context3.next = 14;
                  break;
                }
                throw new _ParameterError2.default('statusCode, blockMessage', {
                  statusCode: statusCode,
                  blockMessage: blockMessage
                }, '', 'Either statusCode or blockMessage is required if blocked is true.');
              case 14:
                return _context3.abrupt('return', this.makeRequest({
                  method: 'POST',
                  url: 'virtualbrowser',
                  headers: {
                    'X-Renderer-Key': rendererId
                  },
                  body: virtualBrowser,
                  queryParameters: {
                    domain: domain,
                    blocked: blocked,
                    statusCode: statusCode,
                    blockMessage: blockMessage
                  }
                }));
              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function checkInVirtualBrowser(_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      }
      return checkInVirtualBrowser;
    }()
  }]);
  return WebcacheApi;
}(_BaseApi3.default);
exports.default = WebcacheApi;